import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import location from "../assests/img/location.png";
import opd from "../assests/img/opd.png";
import cc from "../assests/img/cc.png";
import phone from "../assests/img/phone.png";
import email from "../assests/img/email.png";
import flogo from "../assests/img/logo.png";
import VisitorCounter from "./VisitorCounter";

// ---- Link data: change paths here to match your <Route> paths in App.js ----
const quickLinks = [
  { label: "About Us", path: "/about-us/the-college" },
  { label: "Departments", path: "departments/non-clinical/anatomy" },
  { label: "Academic", path: "/academic/courses-available-status-of-recognition" },
  { label: "Staff", path: "/staff/teaching" },
  { label: "Admissions", path: "notice-board/admissions" },
  { label: "Results", path: "/notice-board/results" },
  { label: "Tenders", path: "/notice-board/tenders" },
];

const importantLinks = [
  { label: "Anti-Ragging", path: "/anti-ragging" },
  { label: "RTI", path: "#" },              // placeholder
  { label: "Citizen Charter", path: "#" },   // placeholder
  { label: "NMC MARB Data", path: "#" },     // placeholder
  { label: "Govt. Approval", path: "/govt-approval", external: true },
  { label: "Photo Gallery", path: "/gallery/college" },
  { label: "Site Map", path: "/site-map" },
];

// Picks the right element: placeholder, external/PDF, or internal route
function FooterLink({ label, path, external }) {
  if (path === "#") {
    return (
      <li>
        <a href="#" onClick={(e) => e.preventDefault()}>{label}</a>
      </li>
    );
  }

  return (
    <li>
      {external ? (
        <a href={path} target="_blank" rel="noopener noreferrer">{label}</a>
      ) : (
        <Link to={path} onClick={() => window.scrollTo(0, 0)}>{label}</Link>
      )}
    </li>
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        {/* Brand column */}
        <div className="footer-col footer-brand">
          <div className="footer-brand-head" style={{ border: "none" }}>
            <h3 className="footer-logo-text">
              <img src={flogo} alt="logo" style={{ width: "52px", float: "left" }} />
            </h3>
            <p className="footer-tagline">
              M.K.C.G. Medical<br />College &amp; Hospital
            </p>
          </div>
          <p className="footer-desc">
            Premier medical institution of Southern Odisha, established in 1962.
            Under the Department of Health &amp; Family Welfare, Govt. of Odisha.
          </p>
          <p className="footer-emergency-label">Emergency Numbers</p>

          <p className="ft contact-row">
            <img src={opd} alt="opd" /> OPD: <a href="tel:06802290137">0680-2290137</a>
          </p>
          <p className="ft contact-row">
            <img src={cc} alt="cc" /> Casualty: <a href="tel:06802290851">0680-2290851</a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            {quickLinks.map((l) => (
              <FooterLink key={l.label} {...l} />
            ))}
          </ul>
        </div>

        {/* Important */}
        <div className="footer-col">
          <h4 className="footer-heading">Important</h4>
          <ul className="footer-links">
            {importantLinks.map((l) => (
              <FooterLink key={l.label} {...l} />
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-heading">Contact Us</h4>
          <address className="footer-address">
            <p>
              <img src={location} alt="location" /> Dean and Principal, M.K.C.G Medical
              College, Berhampur, Ganjam, Odisha – 760 004
            </p>
            <p className="contact-row">
              <img src={phone} alt="phone" />
              <a href="tel:06802292746">(0680) 2292746</a>
            </p>
            <p className="contact-row">
              <img src={phone} alt="phone" /> (0680) 2292809
            </p>

            <div className="contact-row">
              <img src={email} alt="email" />
              <span style={{ color: "#ffa940" }}>principal.mkcgmc@gov.in</span>
            </div>

            <div className="contact-row">
              <img src={email} alt="email" />
              <span style={{ color: "#ffa940" }}>mkcgmc.bam@gmail.com</span>
            </div>

            <div className="contact-row">
              <img src={email} alt="email" />
              <span style={{ color: "#ffa940" }}>prin_mkcgmcberhampur@yahoo.com</span>
            </div>
          </address>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} M.K.C.G. Medical College &amp; Hospital, Berhampur.
            All rights reserved.
          </p>
          <VisitorCounter />
          <p className="anti-ragging">Designed by Orisys Infotech</p>
        </div>
      </div>
    </footer>
  );
}
